import { render } from "./pagination_advance.vue?vue&type=template&id=38300985"
import script from "./pagination_advance.vue?vue&type=script&lang=js"
export * from "./pagination_advance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__